import { FC } from 'react';

export const WlasExternalLinkIcon: FC = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" style={{ flexShrink: 0 }}>
    <path
      d="M6 2H2.5C1.67 2 1 2.67 1 3.5V11.5C1 12.33 1.67 13 2.5 13H10.5C11.33 13 12 12.33 12 11.5V8M8 1H13M13 1V6M13 1L6 8"
      stroke="currentColor"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
